import React from 'react';

import { Text } from '@reckon-web/text';

interface IActivityPropertyString {
  value?: string | null;
}

// ActivityProperty String = 1
export const ActivityPropertyString = ({ value }: IActivityPropertyString) => (
  <Text size="small" weight="semibold">
    {value ? value : ''}
  </Text>
);
